class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Hover intent configuration
    this.openDelay = 120; // ms before opening on hover
    this.closeDelay = 250; // ms before closing on mouse leave
    this.openTimeout = null;
    this.closeTimeout = null;

    // Only apply hover behavior on desktop
    this.isDesktop = window.matchMedia('(min-width: 990px)');

    // Initialize hover intent if on desktop and has data-hover-menu attribute
    if (this.mainDetailsToggle.hasAttribute('data-hover-menu')) {
      this.initHoverIntent();
    }
  }

  initHoverIntent() {
    const summary = this.mainDetailsToggle.querySelector('summary');

    // Open on hover with delay
    summary.addEventListener('mouseenter', () => {
      if (!this.isDesktop.matches) return;
      this.clearTimeouts();
      this.openTimeout = setTimeout(() => {
        this.open();
      }, this.openDelay);
    });

    // Keep open while hovering over menu content
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      if (!this.isDesktop.matches) return;
      this.clearTimeouts();
    });

    // Close with delay when leaving
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      if (!this.isDesktop.matches) return;
      this.clearTimeouts();
      this.closeTimeout = setTimeout(() => {
        this.close();
      }, this.closeDelay);
    });

    // Prevent default click behavior on summary (click still works for accessibility)
    summary.addEventListener('click', (e) => {
      if (!this.isDesktop.matches) return;
      e.preventDefault();
      // Toggle on click for accessibility
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  clearTimeouts() {
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  close() {
    this.clearTimeouts();
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
